export {
  makeReduxID,
  makeQuery,
} from '@console/dynamic-plugin-sdk/src/utils/k8s/hooks/k8s-watcher';
